import './styles/Footer.scss';
import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom'

function Footer() {
    const location = useLocation();

    const [theme, setTheme] = useState('');

    function isLight() {
        if (location.pathname === '/token') {
            return setTheme('dark');
        }
        if (theme !== '') {
            setTheme('');
        }
    }

    useEffect(() => {
        isLight();
    }, [location]);


    return (
        <section className={"footer " + theme}>
            <div className="container">
                <div className="colorLine"></div>
                <div className="bottomLine">
                    <p className="desc3">© 2021 Paribus, LLC</p>
                    <div className="social">
                        <a href="https://t.me/paribus_io" target="blank">
                            <svg
                            viewBox="0 0 21 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                                d="M18.665 0.717064L0.934999 7.55406C-0.275001 8.04006 -0.268 8.71506 0.713 9.01606L5.265 10.4361L15.797 3.79106C16.295 3.48806 16.75 3.65106 16.376 3.98306L7.843 11.6841H7.841L7.843 11.6851L7.529 16.3771C7.989 16.3771 8.192 16.1661 8.45 15.9171L10.661 13.7671L15.26 17.1641C16.108 17.6311 16.717 17.3911 16.928 16.3791L19.947 2.15106C20.256 0.912064 19.474 0.351064 18.665 0.717064Z"
                            />
                            </svg>
                        </a>
                        <a href="https://twitter.com/paribus_io" target="blank">
                            <svg
                            viewBox="0 0 20 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                                d="M17.633 3.978C17.646 4.153 17.646 4.327 17.646 4.501C17.646 9.826 13.593 15.962 6.186 15.962C3.904 15.962 1.784 15.301 0 14.153C0.324 14.19 0.636 14.203 0.973 14.203C2.856 14.203 4.589 13.567 5.974 12.482C4.203 12.445 2.719 11.285 2.207 9.689C2.456 9.726 2.706 9.751 2.968 9.751C3.329 9.751 3.692 9.701 4.029 9.614C2.182 9.24 0.799 7.619 0.799 5.661V5.611C1.336 5.91 1.959 6.097 2.619 6.122C1.534 5.4 0.823 4.165 0.823 2.768C0.823 2.02 1.022 1.334 1.371 0.736C3.354 3.179 6.335 4.776 9.677 4.951C9.615 4.651 9.577 4.34 9.577 4.028C9.577 1.808 11.373 0 13.605 0C14.765 0 15.812 0.486 16.548 1.272C17.458 1.097 18.33 0.76 19.104 0.299C18.805 1.234 18.168 2.02 17.333 2.519C18.144 2.431 18.93 2.207 19.652 1.895C19.104 2.693 18.419 3.404 17.633 3.978Z"
                            />
                            </svg>
                        </a>
                        <a
                            href="https://www.linkedin.com/company/paribusdefi/"
                            target="blank"
                        >
                            <svg
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                                d="M17 0H1C0.447 0 0 0.448 0 1V17C0 17.552 0.447 18 1 18H17C17.553 18 18 17.552 18 17V1C18 0.448 17.553 0 17 0ZM5.339 15.337H2.667V6.747H5.339V15.337ZM4.003 5.574C3.147 5.574 2.455 4.88 2.455 4.026C2.455 3.172 3.146 2.478 4.003 2.478C4.857 2.478 5.551 3.171 5.551 4.026C5.551 4.881 4.857 5.574 4.003 5.574ZM15.338 15.337H12.669V11.16C12.669 10.164 12.651 8.883 11.281 8.883C9.891 8.883 9.68 9.969 9.68 11.09V15.338H7.013V6.748H9.573V7.922H9.61C9.965 7.247 10.837 6.535 12.134 6.535C14.838 6.535 15.337 8.313 15.337 10.627V15.337H15.338Z"
                            />
                            </svg>
                        </a>
                    </div>
                    <div className="policy">
                        <a className="desc3" href="https://stake.paribus.io" target="_blank" rel="noopener noreferrer">
                            Staking
                        </a>
                        <a href="/documents/PARIBUS-Litepaper-V1.0.pdf" target="_blank" rel="noopener noreferrer" className="desc3">Litepaper</a>
                        <a href="#" className="desc3">Terms</a>
                        <a href="#" className="desc3">Privacy</a>
                    </div>
                </div>
            </div>
        </section>
    )
}
            
export default Footer;